import { defineComponent } from "vue";
import VoiceViewer from "./voice.js";
import ChannelPositionChange from "./components/ChannelPositionChange.jsx";

export default defineComponent({

    props: [ "log", "members", "channels" ],

    setup(props) {
        return () => {
            if (props.log.type === "channel_position_update")
                return <ChannelPositionChange log={props.log} />;

            return <VoiceViewer {...props} />;
        };
    },
});
